export default __webpack_public_path__ + "static/Pic-3-895179b6642c101bb8444f0bb9b1c68b.png";